/* Accordion Block JS File */
import collapse from 'bootstrap';
$(document).ready(function() {
	if ($(".accordion-wrapper").length > 0) {
		// $('.accordion-wrapper .accordion').collapse().on('hide.bs.collapse hidden.bs.collapse show.bs.collapse shown.bs.collapse', function(e) {
		// 	TweenMax.to(window, 0.5, { scrollTo: { y: scrollSnap.activeSnap, autoKill: false}, ease: Power4.easeOut });
		// });
	}
});
